(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gfg-product-rotator"] && !Shopify.designMode) return;
  try {
    
  class GfgProductRotator extends HTMLElement {
    connectedCallback() {
      this._panels   = Array.from(this.querySelectorAll('.gfg-rotator__panel'));
      this._tabs     = Array.from(this.querySelectorAll('.gfg-rotator__tab'));
      this._dots     = Array.from(this.querySelectorAll('.gfg-rotator__dot'));
      this._viewAlls = Array.from(this.querySelectorAll('.gfg-rotator__view-all-link'));
      this._bar      = this.querySelector('.gfg-rotator__progress-bar');
      this._current  = 0;
      this._total    = this._panels.length;
      this._ms       = parseInt(this.dataset.interval, 10) || 5000;

      if (this._total <= 1) return;

      this._tabs.forEach((t, i) => t.addEventListener('click', () => this._goTo(i, true)));
      this._dots.forEach((d, i) => d.addEventListener('click', () => this._goTo(i, true)));
      this.addEventListener('mouseenter', () => this._pause());
      this.addEventListener('mouseleave', () => this._resume());
      this._resume();
    }

    disconnectedCallback() { this._pause(); }

    _goTo(idx, reset = false) {
      if (idx === this._current) return;
      const old = this._panels[this._current];
      old.classList.add('is-fading');
      setTimeout(() => {
        old.hidden = true;
        old.classList.remove('is-fading');
        this._current = idx;
        this._panels[idx].hidden = false;
        this._sync();
      }, 400);
      if (reset) { this._pause(); this._resume(); }
    }

    _next() { this._goTo((this._current + 1) % this._total); }

    _sync() {
      const i = this._current;
      this._panels.forEach((p, j) => p.classList.toggle('is-active', j === i));
      this._tabs.forEach((t, j) => { t.classList.toggle('is-active', j === i); t.setAttribute('aria-selected', String(j === i)); });
      this._dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
      this._viewAlls.forEach((v, j) => { v.classList.toggle('is-active', j === i); v.hidden = (j !== i); });
    }

    _pause() {
      clearInterval(this._timer);
      if (this._bar) this._bar.style.animationPlayState = 'paused';
    }

    _resume() {
      this._pause();
      if (this._bar) {
        const b = this._bar.cloneNode(true);
        this._bar.replaceWith(b);
        this._bar = b;
      }
      this._timer = setInterval(() => this._next(), this._ms);
    }
  }

  if (!customElements.get('gfg-product-rotator')) {
    customElements.define('gfg-product-rotator', GfgProductRotator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gfg-slideshow"] && !Shopify.designMode) return;
  try {
    
  class GfgSlideshow extends HTMLElement {
    connectedCallback() {
      this._slides = Array.from(this.querySelectorAll('.gfg-slideshow__slide'));
      this._dots = Array.from(this.querySelectorAll('.gfg-slideshow__dot'));
      this._prevBtn = this.querySelector('.gfg-slideshow__arrow--prev');
      this._nextBtn = this.querySelector('.gfg-slideshow__arrow--next');
      this._current = 0;
      this._total = this._slides.length;
      this._ms = parseInt(this.dataset.interval, 10) || 5000;

      if (this._total <= 1) return;

      this._prevBtn?.addEventListener('click', () => this._goTo(this._current - 1, true));
      this._nextBtn?.addEventListener('click', () => this._goTo(this._current + 1, true));
      this._dots.forEach((d, i) => d.addEventListener('click', () => this._goTo(i, true)));

      this.addEventListener('mouseenter', () => this._pause());
      this.addEventListener('mouseleave', () => this._resume());

      this._resume();
    }

    disconnectedCallback() {
      this._pause();
    }

    _goTo(idx, reset = false) {
      idx = ((idx % this._total) + this._total) % this._total;
      if (idx === this._current) return;

      this._slides[this._current].classList.remove('is-active');
      this._current = idx;
      this._slides[idx].classList.add('is-active');
      this._sync();

      if (reset) {
        this._pause();
        this._resume();
      }
    }

    _next() {
      this._goTo(this._current + 1);
    }

    _sync() {
      this._slides.forEach((s, i) => {
        const active = i === this._current;
        s.classList.toggle('is-active', active);
        // toggle hidden so pointer-events and accessibility are correct
        if (active) {
          s.removeAttribute('hidden');
        } else {
          s.setAttribute('hidden', '');
        }
      });
      this._dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === this._current);
        d.setAttribute('aria-selected', String(i === this._current));
      });
    }

    _pause() {
      clearInterval(this._timer);
    }
    _resume() {
      this._pause();
      this._timer = setInterval(() => this._next(), this._ms);
    }
  }

  if (!customElements.get('gfg-slideshow')) {
    customElements.define('gfg-slideshow', GfgSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
